import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { InputForm, InputHidden } from 'controls/Input'
import Button from 'controls/Button'
import { Row, Col } from 'flexbox'
import styles from './style'
import { IonIcon } from 'controls'
import { common } from '../styles'
import { colors } from 'theme'
import Editor from 'components/Editor'
import brokerNoteValidator from 'app/validators/brokerNote'

export class BrokerNote extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editorState: ''
    }
  }

  onEditorStateChange = editorState =>
    this.setState({
      editorState
    })

  static propTypes = {
    style: PropTypes.object,
    centered: PropTypes.bool
  }

  static defaultProps = {
    style: {},
    centered: false
  }

  render() {
    const { editorState } = this.state
    const { handleSubmit, invalid, style, centered } = this.props
    return (
      <form className="form-container" onSubmit={handleSubmit} style={style}>
        <h4>
          <IonIcon
            icon="chatbubbles"
            style={{ fontSize: '20px', color: colors.articBlue, marginRight: '10px' }}
          />
          Agregar Nota
        </h4>
        <p className="legend">{' '}</p>
        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="title"
              id="title"
              component={InputForm}
              placeholder="Título de la nota"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Editor
              value={editorState}
              onChange={this.onEditorStateChange}
              className="editor-container form-input-margin"
            />
            <Field
              name="content"
              id="content"
              component={InputHidden}
              currentValue={editorState}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="actions">
            <Button
              color="primary"
              fullWidth
              type="submit"
              className="submit"
              disabled={invalid}
            >
              Agregar nota
            </Button>
          </Col>
        </Row>
        <style jsx>{styles}</style>
        <style jsx>{common}</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'BrokerNote',
  validate: brokerNoteValidator
}

export const ReduxBrokerNote = reduxForm(formConfig)(BrokerNote)

export default BrokerNote
